import { paymentsTypes, swiftTypes } from 'constants/pay.constants';
import _ from 'lodash';

export function getPaymentFee(pay, payFees) {
	let fee: number = 0;
	if (_.isEqual(pay.paymentType, paymentsTypes.LOCAL)) {
		fee = payFees?.regular ? payFees?.regular : 0;
	}
	if (_.isEqual(pay.paymentType, paymentsTypes.PRIORITY)) {
		if (_.isEqual(swiftTypes.OUR, pay.swift)) {
			fee = payFees?.priority?.ours ? payFees?.priority?.ours : 0;
		} else {
			fee = payFees?.priority?.shared ? payFees?.priority?.shared : 0;
		}
	}
	return fee;
}
